<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_v"></a>
<p class="fmtitle">Contents</p>
<p class="leaf1"><img alt="images" height="9" src="images/leaf.jpg" width="28"/></p>
<p class="content"><i><a href="#/05_Illustrations">List of Illustrations</a></i></p>
<p class="content"><i><a href="#/06_Maps">List of Maps</a></i></p>
<p class="content"><i><a href="#/07_Preface">Preface</a></i></p>
<p class="content"><i><a href="#/08_Acknowledgements">Acknowledgements</a></i></p>
<p class="content1"><a href="#/09_Introduction">Introduction</a></p>
<p class="content1"><b><a href="#/10_Part01">Part One: Scotsman</a></b></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><a href="#/11_Chapter01">1</a></td>
<td valign="top"><a href="#/11_Chapter01">Eskdale Childhood, 1769–1782</a></td>
</tr>
</tbody></table>
<p class="content1"><b><a href="#/12_Part02">Part Two: Soldier</a></b></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><a href="#/13_Chapter02">2</a></td>
<td valign="top"><a href="#/13_Chapter02">The Madras Army, 1783–1794</a></td>
</tr>
<tr>
<td valign="top"><a href="#/14_Chapter03">3</a></td>
<td valign="top"><a href="#/14_Chapter03">Britain, The Cape and Madras, 1794–1798</a></td>
</tr>
<tr>
<td valign="top"><a href="#/15_Chapter04">4</a></td>
<td valign="top"><a href="#/15_Chapter04">Hyderabad, 1798</a></td>
</tr>
<tr>
<td valign="top"><span href="#/16_Chapter05" title="Link target outside of Sample">5</span></td>
<td valign="top"><span href="#/16_Chapter05" title="Link target outside of Sample">Mysore, 1799</span></td>
</tr>
</tbody></table>
<p class="content1"><b><span href="#/17_Part03" title="Link target outside of Sample">Part Three: Diplomat</span></b></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><span href="#/18_Chapter06" title="Link target outside of Sample">6</span></td>
<td valign="top"><span href="#/18_Chapter06" title="Link target outside of Sample">Envoy to Persia, 1799</span></td>
</tr>
<tr>
<td valign="top"><span href="#/19_Chapter07" title="Link target outside of Sample">7</span></td>
<td valign="top"><span href="#/19_Chapter07" title="Link target outside of Sample">The First Persian Mission, 1800–1801</span></td>
</tr>
<tr>
<td valign="top"><span href="#/20_Chapter08" title="Link target outside of Sample">8</span></td>
<td valign="top"><span href="#/20_Chapter08" title="Link target outside of Sample">Private Secretary – ‘Send Malcolm’, 1801–1802</span></td>
</tr>
<tr>
<td valign="top"><span href="#/21_Chapter09" title="Link target outside of Sample">9</span></td>
<td valign="top"><span href="#/21_Chapter09" title="Link target outside of Sample">Private Secretary – Scandal in Hyderabad</span></td>
</tr>
<tr>
<td valign="top"><span href="#/22_Chapter10" title="Link target outside of Sample">10</span></td>
<td valign="top"><span href="#/22_Chapter10" title="Link target outside of Sample">Private Secretary – Lord Wellesley’s Factotum, 1801–1802</span></td>
</tr>
<tr>
<td valign="top"><span href="#/23_Chapter11" title="Link target outside of Sample">11</span></td>
<td valign="top"><span href="#/23_Chapter11" title="Link target outside of Sample">Private Secretary – The College of Fort William, 1801–1802</span></td>
</tr>
<tr>
<td valign="top"><span href="#/24_Chapter12" title="Link target outside of Sample">12</span></td>
<td valign="top"><span href="#/24_Chapter12" title="Link target outside of Sample">The Mahrattas – Peace and War, 1803</span></td>
</tr>
<tr>
<td valign="top"><a id="page_vi"></a><span href="#/25_Chapter13" title="Link target outside of Sample">13</span></td>
<td valign="top"><span href="#/25_Chapter13" title="Link target outside of Sample">The Mahrattas – Scindiah, 1804</span></td>
</tr>
<tr>
<td valign="top"><span href="#/26_Chapter14" title="Link target outside of Sample">14</span></td>
<td valign="top"><span href="#/26_Chapter14" title="Link target outside of Sample">The End of the Wellesley Era, 1805</span></td>
</tr>
<tr>
<td valign="top"><span href="#/27_Chapter15" title="Link target outside of Sample">15</span></td>
<td valign="top"><span href="#/27_Chapter15" title="Link target outside of Sample">The Mahrattas, 1805–1807</span></td>
</tr>
<tr>
<td valign="top"><span href="#/28_Chapter16" title="Link target outside of Sample">16</span></td>
<td valign="top"><span href="#/28_Chapter16" title="Link target outside of Sample">Mysore – Love and Marriage, 1807–1808</span></td>
</tr>
<tr>
<td valign="top"><span href="#/29_Chapter17" title="Link target outside of Sample">17</span></td>
<td valign="top"><span href="#/29_Chapter17" title="Link target outside of Sample">The Second Persian Mission, 1808</span></td>
</tr>
<tr>
<td valign="top"><span href="#/30_Chapter18" title="Link target outside of Sample">18</span></td>
<td valign="top"><span href="#/30_Chapter18" title="Link target outside of Sample">Mutiny at Masulipatam, 1809</span></td>
</tr>
<tr>
<td valign="top"><span href="#/31_Chapter19" title="Link target outside of Sample">19</span></td>
<td valign="top"><span href="#/31_Chapter19" title="Link target outside of Sample">The Third Persian Mission, 1810</span></td>
</tr>
<tr>
<td valign="top"><span href="#/32_Chapter20" title="Link target outside of Sample">20</span></td>
<td valign="top"><span href="#/32_Chapter20" title="Link target outside of Sample">Baghdad and Back, 1810</span></td>
</tr>
<tr>
<td valign="top"><span href="#/33_Chapter21" title="Link target outside of Sample">21</span></td>
<td valign="top"><span href="#/33_Chapter21" title="Link target outside of Sample">Persian Postscript, 1811–1833</span></td>
</tr>
</tbody></table>
<p class="content1"><b><span href="#/34_part04" title="Link target outside of Sample">Part Four: Author</span></b></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><span href="#/35_Chapter22" title="Link target outside of Sample">22</span></td>
<td valign="top"><span href="#/35_Chapter22" title="Link target outside of Sample">Bombay, 1811</span></td>
</tr>
<tr>
<td valign="top"><span href="#/36_Chapter23" title="Link target outside of Sample">23</span></td>
<td valign="top"><span href="#/36_Chapter23" title="Link target outside of Sample">England – Family, Career and the Literary World, 1812–1816</span></td>
</tr>
</tbody></table>
<p class="content1"><b><span href="#/37_part05" title="Link target outside of Sample">Part Five: Proconsul</span></b></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><span href="#/38_Chapter24" title="Link target outside of Sample">24</span></td>
<td valign="top"><span href="#/38_Chapter24" title="Link target outside of Sample">India – Shuttle Diplomacy, 1817</span></td>
</tr>
<tr>
<td valign="top"><span href="#/39_Chapter25" title="Link target outside of Sample">25</span></td>
<td valign="top"><span href="#/39_Chapter25" title="Link target outside of Sample">India – War, 1817–1818</span></td>
</tr>
<tr>
<td valign="top"><span href="#/40_Chapter26" title="Link target outside of Sample">26</span></td>
<td valign="top"><span href="#/40_Chapter26" title="Link target outside of Sample">India – Surrender of the Peshwah, 1818</span></td>
</tr>
<tr>
<td valign="top"><span href="#/41_Chapter27" title="Link target outside of Sample">27</span></td>
<td valign="top"><span href="#/41_Chapter27" title="Link target outside of Sample">India – Ruler of Central India, 1818–1821</span></td>
</tr>
</tbody></table>
<p class="content1"><b><span href="#/42_part06" title="Link target outside of Sample">Part Six: Ideologue</span></b></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><span href="#/43_Chapter28" title="Link target outside of Sample">28</span></td>
<td valign="top"><span href="#/43_Chapter28" title="Link target outside of Sample">Civil Governance – Three Scots in Western India</span></td>
</tr>
<tr>
<td valign="top"><span href="#/44_Chapter29" title="Link target outside of Sample">29</span></td>
<td valign="top"><span href="#/44_Chapter29" title="Link target outside of Sample">England – Country Gentleman, 1822–1827</span></td>
</tr>
<tr>
<td valign="top"><span href="#/45_Chapter30" title="Link target outside of Sample">30</span></td>
<td valign="top"><span href="#/45_Chapter30" title="Link target outside of Sample">Governor of Bombay – Events, 1827–1830</span></td>
</tr>
<tr>
<td valign="top"><span href="#/46_Chapter31" title="Link target outside of Sample">31</span></td>
<td valign="top"><span href="#/46_Chapter31" title="Link target outside of Sample">Governor of Bombay – Quarrel with the Judges</span></td>
</tr>
<tr>
<td valign="top"><span href="#/47_Chapter32" title="Link target outside of Sample">32</span></td>
<td valign="top"><span href="#/47_Chapter32" title="Link target outside of Sample">England – Last Days, 1831–1833</span></td>
</tr>
</tbody></table>
<p class="content1"><span href="#/48_Postcript" title="Link target outside of Sample">Postscript</span></p>
<a id="page_vii"></a>
<p class="content1"><i><span href="#/49_Appendices" title="Link target outside of Sample">Appendices</span></i></p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="5%"/>
<col width="95%"/>
</colgroup><tbody><tr>
<td valign="top"><span href="#/50_Appendices01" title="Link target outside of Sample">1</span>.</td>
<td valign="top"><span href="#/50_Appendices01" title="Link target outside of Sample">British Government and EIC Office Holders between 1783 and 1833</span></td>
</tr>
<tr>
<td valign="top"><span href="#/51_Appendices02" title="Link target outside of Sample">2</span>.</td>
<td valign="top"><span href="#/51_Appendices02" title="Link target outside of Sample">Horses – ‘The Khan’</span></td>
</tr>
<tr>
<td valign="top"><span href="#/52_Appendices03" title="Link target outside of Sample">3</span>.</td>
<td valign="top"><span href="#/52_Appendices03" title="Link target outside of Sample">Estimated Population of British India, c.1825–1830</span></td>
</tr>
<tr>
<td valign="top"><span href="#/53_Appendices04" title="Link target outside of Sample">4</span>.</td>
<td valign="top"><span href="#/53_Appendices04" title="Link target outside of Sample">Finances of Bombay Territories, 1827–1832</span></td>
</tr>
</tbody></table>
<p class="content1"><i><span href="#/54_Glossary" title="Link target outside of Sample">Glossary, Terminology and Spelling</span></i></p>
<p class="content"><span href="#/54_Glossary#gloss1" title="Link target outside of Sample">Glossary of Indian, Anglo-Indian and Persian Words and Phrases</span></p>
<p class="content"><span href="#/55_Note" title="Link target outside of Sample">Note on Terminology</span></p>
<p class="content"><span href="#/55_Note#note1" title="Link target outside of Sample">Note on Spelling</span></p>
<p class="content"><span href="#/55_Note#note2" title="Link target outside of Sample">Spelling of Indian and Persian Names</span></p>
<p class="content1"><i><span href="#/56_Familytree" title="Link target outside of Sample">Family Tree</span></i></p>
<p class="content">      <span href="#/56_Familytree#malcolm" title="Link target outside of Sample">Malcolm of Burnfoot Family</span></p>
<p class="content1"><i><span href="#/57_Abbreviations" title="Link target outside of Sample">Abbreviations</span></i></p>
<p class="content1"><i><span href="#/58_Notes" title="Link target outside of Sample">Notes</span></i></p>
<p class="content1"><i><span href="#/59_Bibliography" title="Link target outside of Sample">Bibliography</span></i></p>
<p class="content1"><i><span href="#/60_Index" title="Link target outside of Sample">Index of People</span></i></p>
<p class="content1"><i><span href="#/61_Generalindex" title="Link target outside of Sample">General Index</span></i></p>
<p class="content1"><i><span href="#/62_Plates" title="Link target outside of Sample">Plate Section</span></i></p>
<a id="page_viii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?7adfeb4f